var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 288,
    viewBox: "0 0 257 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5896_6623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.968 208.033C203.906 208.294 201.104 208.554 197.701 208.855C197.461 212.04 197.241 214.865 197.001 217.93C193.838 218.27 191.257 218.551 188.134 218.871C187.714 221.636 187.254 224.48 186.733 227.886H78.4932C77.9528 225.322 77.3123 222.277 76.6118 218.931C73.9899 218.651 71.428 218.37 68.2656 218.01C67.8253 215.285 67.385 212.461 66.8446 209.055C64.1426 208.694 61.3205 208.314 57.998 207.873L50 169L57.999 138.845L58 69.817C60.5219 69.3763 63.2839 68.8755 66.7064 68.2745C67.1067 65.7503 67.5471 62.9257 68.0674 59.5H164.017L189 40L196 59.5L199 60L206.968 99.2334V208.053V208.033ZM108.155 118.866V177.643H156.831V118.866H108.155Z",
    fill: "url(#paint0_linear_5896_6623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 169L189.432 169.855L188.731 178.93L179.865 179.871L178.464 188.886H70.2237C69.6833 186.322 69.0428 183.277 68.3423 179.931C65.7203 179.651 63.1584 179.37 59.9961 179.01C59.5558 176.285 59.1154 173.461 58.575 170.055L50 169V50.317C52.5219 49.8763 55.0124 49.3755 58.4349 48.7745C58.8352 46.2503 59.2756 43.4257 59.796 40H189V58.3704L199 60V169ZM99.8856 79.8659V138.643H148.562V79.8659H99.8856Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 49,
    width: 11,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 53,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 64,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 72,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 164,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 168,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 158,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 168,
    width: 10,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 76,
    width: 4,
    height: 27,
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5896_6623",
    x: 0,
    y: 0,
    width: 256.969,
    height: 287.887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.848333 0 0 0 0 0.458333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5896_6623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5896_6623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5896_6623",
    x1: 128.484,
    y1: 40,
    x2: 128.484,
    y2: 227.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOHover);
export default __webpack_public_path__ + "static/media/O_hover.0d86043721581efcecfaec1bddc60b68.svg";
export { ForwardRef as ReactComponent };